import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';

// API member input - name and wallet address
type ApiMemberInput = {
  name: string;
  walletAddress: string;
};

type InviteMembersArg = {
  emails: string[]; // Regular members
  apiMembers: ApiMemberInput[]; // API members
};

type InviteResult =
  | {
      email: string;
      success: true;
    }
  | {
      email: string;
      success: false;
      cause: string;
    };

type InviteMembersResponse = InviteResult[];

// Request body sent to the server
type InviteMembersRequestBody = {
  emails: string[];
  apiMembers: Array<{ name: string; eoaAddress: string }>;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: InviteMembersArg }
): Promise<InviteMembersResponse> => {
  const { emails, apiMembers } = arg;
  return await denApi.post<InviteMembersResponse, InviteMembersRequestBody>(
    `admin/organization/invitations`,
    {
      emails,
      // Transform walletAddress to eoaAddress for the server
      apiMembers: apiMembers.map((m) => ({
        name: m.name,
        eoaAddress: m.walletAddress,
      })),
    }
  );
};

export function useInviteMembers(
  swrOptions?: SWRMutationConfiguration<
    InviteMembersResponse,
    Error,
    string,
    InviteMembersArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    InviteMembersResponse,
    Error,
    string,
    InviteMembersArg
  >('admin/organization/invitations', fetcher, swrOptions);

  return {
    inviteMembers: trigger,
    isInviting: isMutating,
    error,
  };
}
